export default __webpack_public_path__ + "static/media/netvrk-v2-9.bae9511a.jpg";